import RegisteredInstallationWidget from './RegisteredInstallationWidget';

export default RegisteredInstallationWidget;
